import { render } from "./rule-view.vue?vue&type=template&id=fb86182c&scoped=true&ts=true"
import script from "./rule-view.vue?vue&type=script&lang=ts"
export * from "./rule-view.vue?vue&type=script&lang=ts"

import "./rule-view.vue?vue&type=style&index=0&id=fb86182c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb86182c"]])

export default __exports__